import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Eventage.css";

const API_BASE_URL = process.env.REACT_APP_BACKEND_API_URL;

const Eventage = () => {
  const navigate = useNavigate();

  const [events, setEvents] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // ==============================
  // FETCH EVENTS
  // ==============================
  const fetchEvents = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios.get(`${API_BASE_URL}/events`);

      setEvents(Array.isArray(response.data) ? response.data : []);
    } catch (err) {
      console.error("Error fetching events:", err);
      setError("Failed to fetch events. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  // ==============================
  // SEARCH FILTER
  // ==============================
  const filteredEvents = events.filter((event) =>
    event?.title?.toLowerCase().includes(search.toLowerCase())
  );

  // ==============================
  // NAVIGATION HANDLERS
  // ==============================
  const handleAddEvent = () => navigate("/admin-panel/events/add");
  const handleView = (id) => navigate(`/events/view/${id}`);
  const handleEdit = (id) => navigate(`/events/edit/${id}`);

  // ==============================
  // DELETE HANDLER WITH CONFIRMATION
  // ==============================
  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this event?"
    );

    if (!confirmDelete) return;

    try {
      setLoading(true);
      await axios.delete(`${API_BASE_URL}/events/${id}`);

      alert("Event deleted successfully!");

      // Remove deleted event from state
      setEvents((prev) => prev.filter((event) => (event._id || event.id) !== id));
    } catch (err) {
      console.error("Failed to delete event:", err.response || err.message);
      alert(
        err.response?.data?.message ||
        "Failed to delete event. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="eventage-container">
      <h1 className="page-title">EVENT PAGE</h1>

      <div className="top-controls">
        <button className="btn btn-primary" onClick={handleAddEvent}>
          + Add Event
        </button>
        <button className="btn btn-gold" onClick={() => window.print()}>
          Print
        </button>
      </div>

      <div className="search-container">
        <input
          type="text"
          placeholder="Search event by title..."
          className="search-input"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {loading && <p>Loading events...</p>}
      {error && <p className="error-text">{error}</p>}

      {!loading && !error && (
        <table className="event-table">
          <thead>
            <tr>
              <th>SN</th>
              <th>Title</th>
              <th>Description</th>
              <th>Venue</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredEvents.length > 0 ? (
              filteredEvents.map((event, index) => {
                const eventId = event._id || event.id;
                return (
                  <tr key={eventId}>
                    <td>{index + 1}</td>
                    <td>{event?.title}</td>
                    <td>{event?.description}</td>
                    <td>{event?.venue}</td>
                    <td>
                      <button
                        className="action-btn view"
                        onClick={() => handleView(eventId)}
                      >
                        View
                      </button>

                      <button
                        className="action-btn edit"
                        onClick={() => handleEdit(eventId)}
                      >
                        Edit
                      </button>

                      <button
                        className="action-btn delete"
                        onClick={() => handleDelete(eventId)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="5" className="no-data">
                  No events found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default Eventage;